import { callService } from '@services/api';
import { useStore } from '@store/index';
import { useQuery } from '@tanstack/react-query';

/**
 * The members of the stack a call belongs to: per member a call id, a case
 * record id, that case's code and that case's program, and nothing else. A
 * stack renders as a list of links, and a link needs none of a call's contents
 * — no phone numbers, no input or output data, no notes, no assets.
 *
 * Only the call that was dialled from needs this. A covered case carries its
 * parent's id, code and program inline on its own call record, so that
 * direction issues no query at all.
 */
export const useCallStack = (callId?: string) => {
  const { selectedOrganizationId, selectedProgramId } = useStore();

  return useQuery({
    queryKey: ['calls', 'stack', selectedOrganizationId, selectedProgramId, callId],
    enabled: Boolean(callId && selectedOrganizationId && selectedProgramId),
    // A call in no stack is a 404, and that is a final answer, not a blip.
    retry: false,
    queryFn: () =>
      callService.getCallStack({
        organization_id: selectedOrganizationId!,
        program_id: selectedProgramId!,
        call_id: callId!,
      }),
  });
};
